/**
 * Dependencies
 */
import { getViewportWidth, getViewportHeight, debounce } from './helpers'

const breakpoints = {
  xs: 300,
  sm: 600,
  md: 800,
  lg: 1200,
  xl: 1600
}

const callbacks = []
let running = false

export function isAbove (width = 0, height = 0) {
  width = breakpoints[width] || width
  height = breakpoints[height] || height
  return getViewportWidth() > width && getViewportHeight() > height
}

export function addResize (callback) {
  if (callback) {
    if (!callbacks.length) {
      window.addEventListener('resize', debounce(() => {
        resize()
      }, 500))
    }
    callbacks.push(callback)
  }
}

function resize () {
  if (!running && callbacks.length) {
    running = true
    runCallbacks()
  }
}

function runCallbacks () {
  callbacks.forEach((callback) => {
    callback()
  })

  running = false
}
